/*
 * Framework
 *
 * Namespace
 */

(function () {
  'use strict';

  // Namespace app
  this.Framework = {
    CONSTANTS: {
      MQ: {
        sm: 640,
        md: 768,
        lg: 1024,
        xl: 1280,
      },
    },
  };
}.call(window));
